import { useEffect, useState } from 'react';
import { isNativePlatform } from '@/lib/platform';

// The app keeps its tabs up to the desktop layout (tablets included); the website only on a
// phone held upright, where its header already drops to an app bar (VOL-277). Landscape phones
// keep the side menu: 56px of tabs would take a seventh of a 390px-high screen.
const APP_TAB_BAR_QUERY = '(max-width: 1023px)';
const WEB_TAB_BAR_QUERY = '(max-width: 767px)';

function tabBarQuery(): string {
  return isNativePlatform() ? APP_TAB_BAR_QUERY : WEB_TAB_BAR_QUERY;
}

/** Whether the bottom tabs stand for the side menu at the current width. */
export function isTabBarShown(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(tabBarQuery()).matches
    : isNativePlatform();
}

export function useTabBarShown(): boolean {
  const [shown, setShown] = useState(isTabBarShown);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const query = window.matchMedia(tabBarQuery());
    const onChange = () => setShown(query.matches);
    onChange();
    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
  }, []);

  return shown;
}
